var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3875 6.97412C19.6954 6.67889 20.199 6.67503 20.5123 6.96533C20.8254 7.2557 20.8295 7.73053 20.5216 8.02587L11.1393 17.0259C10.8421 17.3108 10.3599 17.3261 10.0432 17.0603L3.51651 11.5818C3.1885 11.3063 3.15919 10.832 3.45126 10.5227C3.74338 10.2134 4.24644 10.1865 4.57452 10.4619L10.5357 15.4651L19.3875 6.97412Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2df211270ad48997bd8dcbcc54b6ec2f.svg";
export { ForwardRef as ReactComponent };